export default "__VITE_ASSET__CA2OyNgR__"